import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const DragIcon = styled(FontAwesomeIcon)`
  cursor: grab;
  color: #999;
`;
